import React, { useEffect, useState } from 'react';

import { IonCheckbox } from '@ionic/react';
import styled from 'styled-components';
import { COLOR_ENUM } from '../../theme/color';
import { SIZE_FONT_TYPE } from '../../theme/size';
import {
  VALUE_OPACITY_DATA,
  VALUE_OPACITY_ENUM,
  VALUE_TRANSITION_DATA,
  VALUE_TRANSITION_ENUM,
} from '../../theme/value';
import { TextElem } from '../text';

export const Elem: React.FC<{
  name?: string;
  tid?: string;
  tvalue?: object;
  text?: string;
  textSize?: SIZE_FONT_TYPE;
  checked?: boolean;
  onClick?: any;
  isLoading?: boolean;
  onChange?: any;
  isCroco?: boolean;
  isMama?: boolean;
  href?: string;
  hrefTitle?: string;
  href2?: string;
  hrefTitle2?: string;
  hrefAnd?: string;
}> = ({
  checked = false,
  onClick,
  tid,
  tvalue,
  text = null,
  textSize = 'main',
  isLoading,
  onChange,
  name,
  isCroco,
  isMama,
  href,
  hrefTitle,
  href2,
  hrefTitle2,
  hrefAnd,
}) => {
  const [status, setStatus] = useState<boolean>(checked);
  useEffect(() => {
    setStatus(checked);
  }, [checked]);

  const handleClick = (e: any) => {
    e.stopPropagation();

    if (!isLoading) {
      setStatus(!status);
      if (onClick) {
        onClick();
      }
    }

    e.target.name = name;
    e.target.value = !status;

    if (onChange) {
      onChange(e);
    }
  };

  const textProps = {
    size: textSize,
    lineHeight: false,
    color: (isCroco ? 'white' : 'black') as any,
    tvalue,
    fontFamily: (isMama ? 'RF Dewi' : 'Dela Gothic One') as any,
    type: (isMama ? 'bold' : 'regular') as any,
  };

  return (
    <Container onClick={handleClick}>
      <Checkbox
        checked={status}
        disabled={isLoading}
        name={name}
        slot="center"
      />

      {/* без href */}
      {!href && (
        <TextElemStyled {...textProps} tid={tid}>
          {text && text}
        </TextElemStyled>
      )}

      {/* одна ссылка */}
      {href && !href2 && (
        <HrefContainer>
          <TextElemStyled {...textProps} tid={tid}>
            {text && text}
          </TextElemStyled>
          <HrefStyled isCroco={isCroco} target="_blank" href={href}>
            <TextElem {...textProps} tid={hrefTitle} />
          </HrefStyled>
        </HrefContainer>
      )}

      {/* две ссылки */}
      {href && href2 && (
        <HrefContainer>
          <TextElemStyled {...textProps} tid={tid}>
            {text && text}
          </TextElemStyled>
          <HrefStyled isCroco={isCroco} target="_blank" href={href}>
            <TextElem {...textProps} tid={hrefTitle} />
          </HrefStyled>
          {hrefAnd && (
            <TextElemStyled {...textProps} tid={hrefAnd} />
          )}
          <HrefStyled isCroco={isCroco} target="_blank" href={href2}>
            <TextElem {...textProps} tid={hrefTitle2} />
          </HrefStyled>
        </HrefContainer>
      )}
    </Container>
  );
};

const HrefContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
`;

const TextElemStyled = styled(TextElem)`
  cursor: pointer;
  line-height: 1em;
`;

const Checkbox = styled(IonCheckbox)`
  --size: 20px;
  --checkmark-width: 6px;
  --background-checked: ${({ theme }) => theme[COLOR_ENUM.SUCCESS]};
  --border-color-checked: ${({ theme }) => theme[COLOR_ENUM.SUCCESS]};
  --border-width: 1.5px;
  --border-radius: 6px;
  --border-style: solid;
  --border-color: #d7dde6;
  --checkmark-width: 5px;
  flex-shrink: 0;
  background: transparent;
  transition: color ${VALUE_TRANSITION_DATA[VALUE_TRANSITION_ENUM.HOVER]};

  ::part(container) {
    padding: 4px;
  }
  &:hover {
    opacity: ${VALUE_OPACITY_DATA[VALUE_OPACITY_ENUM.HOVER]};
  }
  min-width: 20px !important;

  margin: 0;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  grid-template-columns: auto 1fr;
  z-index: 1;
`;

const HrefStyled = styled.a<{ isCroco?: boolean }>`
  text-decoration-color: ${({ isCroco }) => (isCroco ? '#ffff' : '#000')};
  line-height: 1em;
`;